import { Gift } from "./Gift"

export interface GiftBundle {
  id: string
  vendorId: string
  name: string
}

export interface GiftBundleCard {
  id: string,
  name: string
  gifts: Gift[]
}

export const giftBundleConverter: firebase.firestore.FirestoreDataConverter<GiftBundle> = {
  toFirestore: (giftBundle) => {
    return {
      name: giftBundle.name,
      vendorId: giftBundle.vendorId
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    return {
      id: snapshot.id,
      vendorId: data.vendorId,
      name: data.name
    }
  }
}
